exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".leaderboard{box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);background-color:#fff;min-height:100px}.leaderboard table{border-collapse:collapse}.leaderboard table tr{border-bottom:1px solid #eee;position:relative}.leaderboard table tr.me{font-weight:700}.leaderboard .loader{height:3px;width:100%;background-color:orange;position:absolute;bottom:0;left:0}.table{margin-bottom:0}.points{text-align:right;padding-right:50px}th{font-weight:400;color:#888;font-style:italic;font-size:80%}@media (max-width:767px){.resp{display:none}}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/game-elements/leaderboard/leaderboard.component.css
// module id = 491
// module chunks = 1